import { Link } from 'react-router-dom';
import { ChevronRight, Trash2, Shield, Clock, Mail, Phone, MapPin, AlertTriangle, CheckCircle, FileText } from 'lucide-react';

const DeleteAccountPage = () => {
  return (
    <div data-testid="delete-account-page" className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-gradient-to-br from-red-600 to-red-800 text-white pt-32 pb-16">
        <div className="container-custom">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-red-200 text-sm mb-6">
            <Link to="/" className="hover:text-white transition-colors">Kryefaqja</Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-white">Fshirja e Llogarisë</span>
          </nav>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-2xl bg-white/10 backdrop-blur flex items-center justify-center">
              <Trash2 className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold">Fshirja e Llogarisë</h1>
              <p className="text-red-200 mt-2">Delete Account</p>
            </div>
          </div>
          
          <p className="text-lg text-red-100 max-w-2xl">
            Informacion i plotë mbi të drejtën tuaj për të fshirë llogarinë dhe të dhënat personale në AlbMove.
          </p>
        </div>
      </section>
      
      {/* Content */}
      <section className="py-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12">
              
              {/* Hyrje */}
              <div className="mb-12">
                <p className="text-slate-700 leading-relaxed mb-6">
                  Në përputhje me <strong>Rregulloren (BE) 2016/679 (GDPR), veçanërisht Neni 17 (E Drejta për Fshirje)</strong> dhe <strong>Ligjin Nr. 9887/2008 "Për Mbrojtjen e të Dhënave Personale"</strong> të Republikës së Shqipërisë, ju keni të drejtë të kërkoni fshirjen e llogarisë suaj dhe të dhënave personale të lidhura me të.
                </p>
                
                <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                  <h3 className="font-semibold text-slate-900 mb-3 flex items-center gap-2">
                    <FileText className="w-5 h-5 text-blue-600" />
                    Informacion mbi Operatorin
                  </h3>
                  <p className="text-slate-700 mb-2">
                    Aplikacioni <strong>AlbMove</strong> operohet nga:
                  </p>
                  <ul className="text-slate-600 space-y-1">
                    <li><strong>Kompania:</strong> C.S.M. Sh.p.k.</li>
                    <li><strong>NIPT:</strong> M21612019M</li>
                    <li><strong>Regjistruar më:</strong> 12/04/2022</li>
                    <li><strong>Zyrë qendrore:</strong> Rruga Muçaj, Godina 1, 1032, Vorë, Tiranë, Shqipëri</li>
                  </ul>
                </div>
              </div>
              
              {/* 1. Si të Fshini Llogarinë */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-red-100 text-red-600 flex items-center justify-center text-lg font-bold">1</span>
                  Si të Fshini Llogarinë
                </h2>
                
                <p className="text-slate-700 mb-4">
                  Përdoruesit mund të fshijnë llogarinë e tyre direkt nga aplikacioni AlbMove duke ndjekur këto hapa:
                </p>
                
                <div className="bg-red-50 rounded-xl p-6 border border-red-100 mb-6">
                  <p className="font-semibold text-red-800 text-lg mb-2">
                    Profile → Cilësimet → Fshi Llogarinë
                  </p>
                  <p className="text-red-700 text-sm">
                    Ose mund të na kontaktoni direkt në support@albmove.al
                  </p>
                </div>
                
                <h3 className="font-semibold text-slate-900 mb-3">Procesi i Fshirjes:</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Konfirmimi i fshirjes përmes aplikacionit ose email-it</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Llogaria çaktivizohet menjëherë pas konfirmimit</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Aksesi në aplikacion bllokohet automatikisht</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Fshirja përfundimtare e të dhënave realizohet brenda <strong>30 ditëve</strong></span>
                  </li>
                </ul>
              </div>
              
              {/* 2. Çfarë Fshihet */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-red-100 text-red-600 flex items-center justify-center text-lg font-bold">2</span>
                  Çfarë Fshihet
                </h2>
                
                <p className="text-slate-700 mb-4">
                  Kur fshini llogarinë tuaj, të dhënat e mëposhtme fshihen përgjithmonë:
                </p>
                
                <div className="grid md:grid-cols-2 gap-4">
                  {[
                    'Emri dhe mbiemri',
                    'Adresa e email-it',
                    'Numri i telefonit',
                    'Dokument identiteti (nëse është ngarkuar)',
                    'Të dhënat e profilit',
                    'Të dhënat e pajisjes',
                    'Të dhënat e përdorimit të aplikacionit',
                    'Preferencat dhe cilësimet'
                  ].map((item, index) => (
                    <div key={index} className="flex items-center gap-3 bg-slate-50 rounded-lg p-3">
                      <Trash2 className="w-4 h-4 text-red-500 flex-shrink-0" />
                      <span className="text-slate-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* 3. Çfarë Ruhet për Arsye Ligjore */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center text-lg font-bold">3</span>
                  Çfarë Ruhet për Arsye Ligjore
                </h2>
                
                <div className="bg-amber-50 rounded-xl p-6 border border-amber-200 mb-6">
                  <div className="flex items-start gap-3">
                    <AlertTriangle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="text-amber-800 font-medium mb-2">Detyrim Ligjor</p>
                      <p className="text-amber-700 text-sm">
                        Në përputhje me <strong>Ligjin Nr. 87/2019 për Fiskalizimin</strong> dhe legjislacionin tatimor shqiptar, 
                        jemi të detyruar të ruajmë disa të dhëna për qëllime ligjore.
                      </p>
                    </div>
                  </div>
                </div>
                
                <p className="text-slate-700 mb-4">
                  Të dhënat e mëposhtme ruhen për <strong>10 vite</strong> pas fshirjes së llogarisë:
                </p>
                
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <Shield className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Të dhënat e transaksioneve financiare</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Shield className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Faturat fiskale të lëshuara</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Shield className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Regjistrimet financiare të kërkuara nga ligji</span>
                  </li>
                </ul>
                
                <p className="text-slate-600 text-sm mt-4 italic">
                  * Këto të dhëna ruhen vetëm për përmbushjen e detyrimeve ligjore dhe nuk përdoren për marketing apo qëllime të tjera.
                </p>
              </div>
              
              {/* 4. Kufizime të Fshirjes */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-slate-200 text-slate-600 flex items-center justify-center text-lg font-bold">4</span>
                  Kufizime të Fshirjes
                </h2>
                
                <p className="text-slate-700 mb-4">
                  Fshirja e llogarisë dhe të dhënave mund të kufizohet ose vonohet në rastet e mëposhtme:
                </p>
                
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-slate-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Hetimesh ligjore në progres</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-slate-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Kërkesash zyrtare nga autoritete shtetërore</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-slate-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Detyrimeve tatimore të papërmbushura</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-slate-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Transaksioneve të pakryera ose kontestuara</span>
                  </li>
                </ul>
              </div>
              
              {/* 5. Konfirmimi i Fshirjes */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-lg font-bold">5</span>
                  Konfirmimi i Fshirjes
                </h2>
                
                <p className="text-slate-700 mb-4">
                  Pas përfundimit të procesit të fshirjes, do të merrni:
                </p>
                
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <Mail className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Email konfirmimi që procesi ka filluar</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                    <span className="text-slate-700">Njoftim përfundimtar kur të dhënat janë fshirë plotësisht</span>
                  </li>
                </ul>
              </div>
              
              {/* 6. Kontakt */}
              <div className="mb-12">
                <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-lg font-bold">6</span>
                  Kontakt për Çështje Privatësie
                </h2>
                
                <p className="text-slate-700 mb-6">
                  Për çdo pyetje ose kërkesë në lidhje me fshirjen e llogarisë ose privatësinë e të dhënave, na kontaktoni:
                </p>
                
                <div className="grid md:grid-cols-3 gap-4">
                  <a 
                    href="mailto:support@albmove.al" 
                    className="flex items-center gap-3 bg-blue-50 rounded-xl p-4 hover:bg-blue-100 transition-colors"
                  >
                    <Mail className="w-6 h-6 text-blue-600" />
                    <div>
                      <p className="text-sm text-blue-600">Email</p>
                      <p className="font-semibold text-slate-900">support@albmove.al</p>
                    </div>
                  </a>
                  
                  <a 
                    href="tel:+355682001818" 
                    className="flex items-center gap-3 bg-blue-50 rounded-xl p-4 hover:bg-blue-100 transition-colors"
                  >
                    <Phone className="w-6 h-6 text-blue-600" />
                    <div>
                      <p className="text-sm text-blue-600">Telefon</p>
                      <p className="font-semibold text-slate-900">+355 68 200 1818</p>
                    </div>
                  </a>
                  
                  <div className="flex items-center gap-3 bg-slate-50 rounded-xl p-4">
                    <MapPin className="w-6 h-6 text-slate-600" />
                    <div>
                      <p className="text-sm text-slate-600">Adresa</p>
                      <p className="font-semibold text-slate-900 text-sm">Rruga Muçaj, Vorë, Tiranë</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Deklarata përfundimtare */}
              <div className="bg-slate-100 rounded-xl p-6 border border-slate-200">
                <p className="text-slate-600 text-sm leading-relaxed">
                  Kjo faqe është përgatitur në përputhje me kërkesat e <strong>Google Play Developer Policy</strong> dhe <strong>Apple App Store Guidelines</strong> për fshirjen e llogarisë së përdoruesit, si dhe me legjislacionin shqiptar dhe europian për mbrojtjen e të dhënave personale.
                </p>
              </div>
              
              {/* Data e përditësimit */}
              <div className="mt-8 pt-6 border-t border-slate-200">
                <p className="text-slate-500 text-sm flex items-center gap-2">
                  <Clock className="w-4 h-4" />
                  Përditësuar më: {new Date().toLocaleDateString('sq-AL', { day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DeleteAccountPage;
